import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["actions", "title", "price", "link", "withConditions", "onClick"];
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { Basket as BasketIcon, ChevronNormalDown } from "../icons";
import noop from "../utils/noop";
import styles from './Basket.css';
var cx = classNames.bind(styles);

var Basket = function Basket(props) {
  var actions = props.actions,
      title = props.title,
      price = props.price,
      link = props.link,
      withConditions = props.withConditions,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? noop : _props$onClick,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      style = _useState4[0],
      setStyle = _useState4[1];

  var ref = useRef(null);

  var handleToggle = function handleToggle() {
    setSelected(!selected);
  };

  useEffect(function () {
    if (withConditions && ref.current) {
      setStyle({
        marginTop: "".concat(ref.current.offsetHeight - 12, "px")
      });
    } else {
      setStyle({});
    }
  }, [withConditions]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('Basket', {
      Basket_selected: selected,
      Basket_open: withConditions
    })
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: cx('Conditions'),
    ref: ref
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('Condition')
  }, "\u042F \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D \u0441\u043E", ' ', /*#__PURE__*/React.createElement("a", {
    href: link,
    className: cx('ConditionLink')
  }, "\u0432\u0441\u0435\u043C\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438")), /*#__PURE__*/React.createElement("button", {
    className: cx('Toggle'),
    type: "button",
    onClick: handleToggle
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('RowWrap'),
    style: style
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('Row'),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('Arrow')
  }, /*#__PURE__*/React.createElement(ChevronNormalDown, {
    color: "N900"
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('BasketIcon')
  }, /*#__PURE__*/React.createElement(BasketIcon, {
    color: "N900"
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('Column')
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('Title')
  }, title), /*#__PURE__*/React.createElement("span", {
    className: cx('Price')
  }, price))), actions));
};

export default Basket;